module.exports = __webpack_public_path__ + "img/coupon-icon.f3f426c9.png";